import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomLoader from '../../common/CustomLoader';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { toast } from 'react-toastify';
import { checkNotificationSettingPermission } from '../../../common/utils/permissions';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../../common/ui/AppSettingsNav';
import { notificationSettingText } from '../../../common/docs/content';
import ParentDocCard from '../../common/ParentDocCard';
import { isProjectReadOnly } from '../../../common/utils/api_utils';

export class NotificationSetting extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    resetToDefault: false,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  createSchemaForNotificationSetting = () => {
    const { appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) return '';
    const { notificationSetting } = projectDetail;
    const { resetToDefault } = this.state;
    if (notificationSetting && !resetToDefault) {
      return {
        ...notificationSetting,
      };
    } else {
      return {
        closeButton: true,
        newestOnTop: true,
        progressBar: true,
        positionClass: 'toast-top-right',
        showDuration: '300',
        hideDuration: '1000',
        timeOut: '5000',
        showEasing: 'swing',
        hideEasing: 'linear',
      };
    }
  };

  optionsList = () => {
    return [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ];
  };

  positionClassOptions = () => {
    return [
      { value: 'toast-top-right', label: 'Top Right' },
      { value: 'toast-bottom-right', label: 'Bottom Right' },
      { value: 'toast-bottom-left', label: 'Bottom Left' },
      { value: 'toast-top-left', label: 'Top Left' },
      { value: 'toast-top-full-width', label: 'Top Full Width' },
      { value: 'toast-bottom-full-width', label: 'Bottom Full Width' },
      { value: 'toast-top-center', label: 'Top Center' },
      { value: 'toast-bottom-center', label: 'Bottom Center' },
    ];
  };

  easingOption = () => {
    return [
      { value: 'swing', label: 'Swing' },
      { value: 'linear', label: 'Linear' },
    ];
  };

  handleTestNotification = (values) => {
    const newValues = {};
    Object.assign(newValues, values);
    Object.entries(newValues).forEach((entry) => {
      const [key, value] = entry;
      if (key === 'positionClass') {
        newValues['position'] = value.replace(/toast-(.*?)/g, '$1');
        delete newValues['positionClass'];
      } else if (key === 'closeButton') {
        newValues['closeOnClick'] = value;
        delete newValues['closeButton'];
      } else if (key === 'progressBar') {
        newValues['hideProgressBar'] = !value;
        delete newValues['progressBar'];
      } else if (key === 'timeOut') {
        newValues['autoClose'] = value;
        delete newValues['timeOut'];
      }
    });
    toast.success('This is Demo', {
      ...newValues,
    });
  };

  handleResetDefault = () => {
    this.setState({ resetToDefault: true });
  };

  handleSubmit = (values) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.addNotificationSetting({
      projectId,
      version,
      data: values,
    });
  };

  showNotificationForm = () => {
    const { appSetting } = this.props;
    const { addNotificationSettingPending, projectDetail } = appSetting;
    const { uuid: projectId } = projectDetail;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForNotificationSetting()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          !isReadOnly && this.handleSubmit(values);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Close Button</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Close Button">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="closeButton"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.optionsList()}
                        value={values['closeButton']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'closeButton'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Newest On Top</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Newest On top">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="newestOnTop"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.optionsList()}
                        value={values['newestOnTop']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'newestOnTop'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Progress Bar</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Progress Bar">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="progressBar"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.optionsList()}
                        value={values['progressBar']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'progressBar'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Position Class</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Position Class">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="positionClass"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.positionClassOptions()}
                        value={values['positionClass']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'positionClass'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Show Easing</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Show Easing">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="showEasing"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.easingOption()}
                        value={values['showEasing']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'showEasing'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Hide Easing</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Hide Easing">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                        </span>
                      </div>
                      <CustomSelect
                        name="hideEasing"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.easingOption()}
                        value={values['hideEasing']}
                        placeholder="-Select one-"
                      />
                      <ErrorMessage name={'hideEasing'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Show Duration</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Show Duration">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('text')}`}></i>
                          <span className="required"></span>
                        </span>
                      </div>
                      <Field
                        name="showDuration"
                        className="form-control form-control-sm"
                        placeholder="Enter Show Duration in milliseconds (Default: 300)"
                      />
                      <ErrorMessage name="showDuration">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Hide Duration</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Hide Duration">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('text')}`}></i>
                          <span className="required"></span>
                        </span>
                      </div>
                      <Field
                        name="hideDuration"
                        className="form-control form-control-sm"
                        placeholder="Enter Hide Duration in milliseconds (Default: 1000)"
                      />
                      <ErrorMessage name="hideDuration">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <div className="col-6">
                    <span className="label text-muted">Time Out</span>
                  </div>
                  <div className="col-12">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Time Out">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('text')}`}></i>
                          <span className="required"></span>
                        </span>
                      </div>
                      <Field
                        name="timeOut"
                        className="form-control form-control-sm"
                        placeholder="Enter Time-out in milliseconds (Default: 5000)"
                      />
                      <ErrorMessage name="timeOut">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row col-sm-12 col-md-12 col-lg-12">
                <div className="col-4 text-left">
                  <button
                    type="button"
                    onClick={() => (isReadOnly ? undefined : this.handleResetDefault(values))}
                    className="btn btn-default btn-md mr-3"
                    disabled={
                      isSubmitting || addNotificationSettingPending || isReadOnly ? 'disabled' : ''
                    }
                    title={isReadOnly ? 'Read-Only Mode' : 'Reset Default'}
                  >
                    <i className={`wb ${drapcodeIcon('reset')}`}></i> Reset Default&nbsp;
                  </button>
                </div>
                <div className="col-8 text-right px-0">
                  <button
                    type="button"
                    onClick={() => this.handleTestNotification(values)}
                    className="btn btn-theme-default-outlined btn-md mr-3"
                    disabled={isSubmitting || addNotificationSettingPending ? 'disabled' : ''}
                  >
                    <i className={`wb ${drapcodeIcon('notification')}`}></i> Test Notification&nbsp;
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={
                      isSubmitting || addNotificationSettingPending || isReadOnly ? 'disabled' : ''
                    }
                    title={isReadOnly ? 'Read-Only Mode' : 'Save'}
                  >
                    <i className={`wb ${drapcodeIcon('save')}`}></i> Save&nbsp;
                    <CustomLoader
                      loading={
                        addNotificationSettingPending !== undefined && addNotificationSettingPending
                      }
                    />
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  render() {
    const isAllowed = checkNotificationSettingPermission();
    if (!isAllowed) {
      return (
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <PermissionDenied message="Notification Setting" />
          </div>
        </div>
      );
    }

    const { appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'notificationSetting'} projectDetail={projectDetail} />
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentCardNoCol
              bgColor="drapcode-violet"
              icon="notification"
              title="Notification Setting"
            >
              {this.showNotificationForm()}
            </ParentCardNoCol>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Notification Setting</b>
          </h5>
          <p>{notificationSettingText}</p>
          <br />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSetting);
